module.exports = __webpack_public_path__ + "assets/img/2569f32cee18db84bb17c59eb62d413f.svg";